import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@material-ui/core';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import theme from './assets/styles/theme';
import 'flag-icons/css/flag-icons.min.css';
import './index.css';
import store from './redux/store';
import MainRouter from './routes/router';
import * as serviceWorker from './serviceWorker';
import i18n from './utils/i18n';

import 'typeface-roboto';

ReactDOM.render(
    <Provider store={store}>
        <I18nextProvider i18n={i18n}>
            <ThemeProvider theme={theme}>
                <MainRouter />
            </ThemeProvider>
        </I18nextProvider>
    </Provider>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
